import { render, staticRenderFns } from "./Footerbar.vue?vue&type=template&id=2bdc6c0e&scoped=true"
import script from "./Footerbar.vue?vue&type=script&lang=js"
export * from "./Footerbar.vue?vue&type=script&lang=js"
import style0 from "./Footerbar.vue?vue&type=style&index=0&id=2bdc6c0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdc6c0e",
  null
  
)

export default component.exports